import { useConfigStore } from '@/store/useConfigStore';
import { WizardProgress } from '@/components/wizard/WizardProgress';
import { Step1RoomWindow } from '@/components/wizard/Step1RoomWindow';
import { Step2CurtainStyle } from '@/components/wizard/Step2CurtainStyle';
import { Step3FabricLining } from '@/components/wizard/Step3FabricLining';
import { Step4Preview } from '@/components/wizard/Step4Preview';
import { Step5Approval } from '@/components/wizard/Step5Approval';
import { CurtainVisualizerModal } from '@/visualizer/CurtainVisualizerModal';
import { Eye } from 'lucide-react';

function App() {
  const { currentStep, nextStep, prevStep, setVisualizerOpen } = useConfigStore();

  const renderStep = () => {
    switch (currentStep) {
      case 0: return <Step1RoomWindow />;
      case 1: return <Step2CurtainStyle />;
      case 2: return <Step3FabricLining />;
      case 3: return <Step4Preview />;
      case 4: return <Step5Approval />;
      default: return <Step1RoomWindow />;
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col font-sans">
      <header className="bg-slate-900 text-white p-4 sticky top-0 z-40 shadow-md flex justify-between items-center">
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-bold">Hail Mary Curtains</h1>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => setVisualizerOpen(true)}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-slate-950 font-bold rounded-full text-xs transition-all shadow-md active:scale-95 cursor-pointer"
          >
            <Eye size={15} />
            <span>3D Room Visualizer</span>
          </button>
          <div className="text-xs font-medium bg-slate-800 px-3 py-1.5 rounded-full text-slate-300">
            Step {currentStep + 1} of 5
          </div>
        </div>
      </header>

      <CurtainVisualizerModal />

      <main className="flex-1 w-full max-w-4xl mx-auto p-4 md:p-8 pb-24">
        <WizardProgress />
        <div className="mt-8 bg-white p-4 md:p-8 rounded-xl shadow-sm border border-slate-100">
          {renderStep()}
        </div>
      </main>

      <footer className="bg-white border-t border-slate-200 p-4 sticky bottom-0 z-50">
        <div className="max-w-4xl mx-auto flex justify-between gap-4">
          <button
            onClick={prevStep}
            disabled={currentStep === 0}
            className="flex-1 md:flex-none px-6 py-3 rounded-lg border border-slate-300 text-slate-700 font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-slate-50 active:bg-slate-100 transition-colors"
          >
            Back
          </button>
          <button
            onClick={nextStep}
            disabled={currentStep === 4}
            className="flex-1 md:flex-none px-6 py-3 rounded-lg bg-amber-500 text-slate-900 font-bold disabled:opacity-50 disabled:cursor-not-allowed hover:bg-amber-400 active:bg-amber-600 transition-colors shadow-sm"
          >
            {currentStep === 3 ? 'Review & Approve' : currentStep === 4 ? 'Done' : 'Next'}
          </button>
        </div>
      </footer>
    </div>
  );
}

export default App;
